const routes = [
  {
    path: "/obra",
    name: "constructionProject",
    component: () => import("@/views/sistema/obras/obra/Obras.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}],
    },
  },
  {
    path: "/obra/em-aberto",
    name: "constructionProjectOpen",
    component: () => import("@/views/sistema/obras/obra/Obras.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Obras em Aberto"}],
      type: "open",
    },
  },
  {
    path: "/obra/em-andamento",
    name: "constructionProjectInProgress",
    component: () => import("@/views/sistema/obras/obra/Obras.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Obras em Andamento"}],
      type: "in_progress",
    },
  },
  {
    path: "/obra/concluido",
    name: "constructionProjectDone",
    component: () => import("@/views/sistema/obras/obra/Obras.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Obras Concluídas"}],
      type: "done",
    },
  },
  {
    path: "/obra/novo",
    name: "constructionProjectNew",
    component: () => import("@/views/sistema/obras/obra/ObraNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Nova Obra"}],
    },
  },
  {
    path: "/obra/:id/editar",
    name: "constructionProjectUpdate",
    component: () => import("@/views/sistema/obras/obra/Composicao.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Editar"}],
    },
  },
  {
    path: "/obra/:id/composicao",
    name: "composition",
    component: () => import("@/views/sistema/obras/obra/Composicao.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/rdo",
    name: "rdo",
    component: () => import("@/views/sistema/obras/rdo/Rdo.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Memória de Obra e RDO"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/rdo/novo",
    name: "rdoNew",
    component: () => import("@/views/sistema/obras/rdo/RdoNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Medição"}],
    },
  },

  {
    path: "/obra/:idConstructionProject/composicao/unidade-construtiva/:idConstructionUnit/rdo/novo",
    name: "rdoConstructionUnitNew",
    component: () => import("@/views/sistema/obras/rdo/RdoNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "RDO"}, {title: "Novo"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/rdo/:id/editar",
    name: "rdoUpdate",
    component: () => import("@/views/sistema/obras/rdo/RdoNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "RDO"}, {title: "Editar"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/unidade-construtiva",
    name: "constructionUnit",
    component: () => import("@/views/sistema/obras/unidadeConstrutiva/UnidadeConstrutiva.vue"),
    meta: {
      breadcrumb: [{title: "Obras"}, {title: "Unidade Construtiva"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/unidade-construtiva/novo", // esse aqui
    name: "constructionUnitNew",
    component: () => import("@/views/sistema/obras/unidadeConstrutiva/UnidadeConstrutivaNew.vue"),
    meta: {
      breadcrumb: [{title: "Obras"}, {title: "Controle de Obras"}, {title: "Nova unidade Construtiva"}],
    },
  },

  {
    path: "/obra/:idConstructionProject/composicao/unidade-construtiva/:id/editar",
    name: "constructionUnitUpdate",
    component: () => import("@/views/sistema/obras/unidadeConstrutiva/UnidadeConstrutivaNew.vue"),
    meta: {
      breadcrumb: [{title: "Obras"}, {title: "Controle de Obras"}, {title: "Unidades Construtivas"}],
    },
  },
  {
    path: "/cadastro/obra/tipo-unidade-construtiva",
    name: "constructionUnitType",
    component: () => import("@/views/cadastros/tipoUnidadeConstrutiva/TipoUnidadeConstrutiva.vue"),
    meta: {
      breadcrumb: [{ title: "Cadastro" }, { title: "Obra" }, { title: "Tipo de Unidade Construtiva" }],
    },
  },
  {
    path: "/cadastro/obra/tipo-unidade-construtiva/novo",
    name: "constructionUnitTypeNew",
    component: () => import("@/views/cadastros/tipoUnidadeConstrutiva/TipoUnidadeConstrutivaNew.vue"),
    meta: {
      breadcrumb: [{ title: "Cadastro" }, { title: "Obra" }, { title: "Tipo de Unidade Construtiva" }, { title: "Novo" }],
    },
  },

  {
    path: "/cadastro/obra/tipo-unidade-construtiva/:id/editar",
    name: "constructionUnitTypeUpdate",
    component: () => import("@/views/cadastros/tipoUnidadeConstrutiva/TipoUnidadeConstrutivaNew.vue"),
    meta: {
      breadcrumb: [{ title: "Cadastro" }, { title: "Obra" }, { title: "Tipo de Unidade Construtiva" }, { title: "Editar" }],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/protocolos-associados",
    name: "associatedProtocols",
    component: () => import("@/views/sistema/obras/ProtocolosAssociados.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Protocolos Associados"}],
    },
  },
  {
    path: "/obra/calculadora",
    name: "calculator",
    component: () => import("@/views/sistema/obras/Calculadora.vue"),
    meta: {
      breadcrumb: [{title: "Obras"}, {title: "Calculadora"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/material",
    name: "material",
    component: () => import("@/views/sistema/obras/material/Material.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Materiais"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/requisicao/:id/visualizar",
    name: "materialRequestView",
    component: () => import("@/views/sistema/almoxarifado/requisicao/RequisicaoView.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Requisição"}, {title: "Visualizar"}],
    },
  },
  {
    path: "/obra/aviso-obra/:type",
    name: "constructionWarning",
    component: () => import("@/views/sistema/obras/AvisoObra.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Aviso de Obras"}],
    },
  },
  {
    path: "/obra/calendario",
    name: "calendar",
    component: () => import("@/views/sistema/obras/Calendario.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Calendário"}],
    },
  },

  {
    path: "/obra/:idConstructionProject/composicao/requisicao/material/novo",
    name: "materialRequestItemNew",
    component: () => import("@/views/sistema/obras/material/MaterialNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Materiais"}, {title: "Novo"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/requisicao/devolucao-transferencia/novo",
    name: "materialDevolutionTransferNew",
    component: () => import("@/views/sistema/obras/requisicao/devolucaoTransferencia/DevolucaoTransferenciaNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Requisição"}, {title: "Devolução/Transferência"}, {title: "Novo"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/requisicao/devolucao-transferencia/:id/editar",
    name: "materialDevolutionTransferUpdate",
    component: () => import("@/views/sistema/obras/requisicao/devolucaoTransferencia/DevolucaoTransferenciaNew.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Requisição"}, {title: "Devolução/Transferência"}, {title: "Editar"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/requisicao/devolucao-transferencia/:id/visualizar",
    name: "materialDevolutionTransferView",
    component: () => import("@/views/sistema/obras/requisicao/devolucaoTransferencia/DevolucaoTransferenciaView.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Requisição"}, {title: "Devolução/Transferência"}, {title: "Visualizar"}],
    },
  },
  {
    path: "/obra/gerenciar-lista-envio",
    name: "manageEmailSendingList",
    component: () => import("@/views/sistema/obras/GerenciarListaEnvio.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Gerenciar Lista de Envio"}],
    },
  },
  {
    path: "/cadastro/obra/lista-envio",
    name: "emailSendingList",
    component: () => import("@/views/cadastros/listaEnvio/ListaEnvio.vue"),
    meta: {
      breadcrumb: [{ title: "Cadastro" }, { title: "Obra" }, { title: "Lista de Envio" }],
    },
  },
  {
    path: "/cadastro/obra/lista-envio/novo",
    name: "emailSendingListNew",
    component: () => import("@/views/cadastros/listaEnvio/ListaEnvioNew.vue"),
    meta: {
      breadcrumb: [{ title: "Cadastro" }, { title: "Obra" }, { title: "Lista de Envio" }, { title: "Novo" }],
    },
  },
  {
    path: "/cadastro/obra/lista-envio/:id/editar",
    name: "emailSendingListUpdate",
    component: () => import("@/views/cadastros/listaEnvio/ListaEnvioNew.vue"),
    meta: {
      breadcrumb: [{ title: "Cadastro" }, { title: "Obra" }, { title: "Lista de Envio" }, { title: "Editar" }],
    },
  },
  {
    path: "/obra/email",
    name: "email",
    component: () => import("@/views/sistema/recursosHumanos/Email.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Emails"}],
    },
  },
  {
    path: "/obra/medicoes",
    name: "measurements",
    component: () => import("@/views/sistema/obras/medicoes/Medicoes.vue"),
    meta: {
      breadcrumb: [{title: "Medições"}, {title: "Todas as Medições"}],
    },
  },
  {
    path: "/obra/medicoes/medicao",
    name: "measurementsMeasurement",
    component: () => import("@/views/sistema/obras/medicoes/Medicao.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Medições"}, {title: "Medição "}],
    },
  },
  {
    path: "/obra/medicoes/materiais",
    name: "materialMeasurement",
    component: () => import("@/views/sistema/obras/medicoes/Materiais.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Medições"}, {title: "Materiais"}],
    },
  },
  {
    path: "/obra/medicoes/protocolo",
    name: "measurementsProtocol",
    component: () => import("@/views/sistema/obras/medicoes/Protocolo.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Medições"}, {title: "Protocolos "}],
    },
  },
  {
    path: "/obra/medicoes/externos",
    name: "measurementsOutsourced",
    component: () => import("@/views/sistema/obras/medicoes/Externo.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Medições"}, {title: "Externos "}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/historico-alteracoes",
    name: "changeHistory",
    component: () => import("@/views/sistema/obras/HistoricoAlteracoes.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Histórico de Alterações"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/composicao/pontuacao",
    name: "points",
    component: () => import("@/views/sistema/obras/pontuacao/Pontuacao.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Pontuações"}],
    },
  },
  {
    path: "/obra/historico-de-avisos",
    name: "warningHistory",
    component: () => import("@/views/sistema/obras/emailAviso/HistoricoGeralAvisos.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Histórico geral de avisos"}],
    },
  },
  {
    path: "/obra/:idConstructionProject/historico-envio-emails",
    name: "sendingHistory",
    component: () => import("@/views/sistema/obras/emailAviso/HistoricoAvisosObra.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Controle de Obras"}, {title: "Histórico de Avisos"}],
    },
  },
  {
    path: "/obra/excluidas",
    name: "deletedConstructionProject",
    component: () => import("@/views/sistema/obras/obra/ObrasExcluidas.vue"),
    meta: {
      breadcrumb: [{title: "Obra"}, {title: "Histórico"}, {title: "Obras Excluídas"}],
    },
  },
]

export default routes
